import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import { FontAwesomeIcon } from '../icon/icon';

const InfoBar = styled.div<{ $type: 'info' | 'warning' | 'error' }>`
  background-color: ${({ $type }) =>
    $type === 'info' ? '#edf5ff' : $type === 'warning' ? '#fff8e1' : '#ffeef0'};
  border: 1px solid
    ${({ $type }) =>
      $type === 'info'
        ? '#edf5ff'
        : $type === 'warning'
          ? '#fff8e1'
          : '#ffeef0'};
  border-radius: 4px;
  width: 100%;
  margin-bottom: 16px;
  padding: 7.5px 1rem;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const InfoContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  padding: 7.5px 0;
`;

const InfoText = styled.span`
  font-size: 14px;
  line-height: 1.2857142857142858em;
  color: #161616;
`;
const InfoBarIcon = styled(FontAwesomeIcon)<{
  $type: 'info' | 'warning' | 'error';
}>`
  && {
    color: ${({ $type }) =>
      $type === 'info'
        ? 'var(--blue-60)'
        : $type === 'warning'
          ? 'var(--yellow-60)'
          : 'var(--red-60)'};
  }
`;

interface AlertProps {
  type: 'info' | 'warning' | 'error';
  content: React.ReactNode;
  icon?: IconDefinition;
  extraContent?: React.ReactNode;
}

export const Alert = ({ type, icon, content, extraContent }: AlertProps) => {
  return (
    <InfoBar $type={type}>
      <InfoContent>
        {icon ? <InfoBarIcon icon={icon} size="lg" $type={type} /> : null}
        <InfoText>{content}</InfoText>
      </InfoContent>
      {extraContent}
    </InfoBar>
  );
};
